/** @format */
import { css } from 'styled-components';

import {
    largeDesktop,
    largeTablet,
    smallTablet,
} from '@toucan/client/global/application';
import { theme } from '@toucan/client/global/theme';

export const styles = css`
    flex: 0 0 74rem;
    max-width: 74rem;
    margin-right: var(--layout-spacing-32);

    * {
        transition: var(--animations-default-duration) all;
    }

    .featured-article-card__image:has(> picture) {
        border-radius: var(--effects-radius-lg);
        box-shadow: var(--effects-shadow-base);
        overflow: hidden;
        aspect-ratio: 16 / 9;

        picture {
            display: flex;
            height: 100%;
        }

        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
    }

    .featured-article-card__details {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: var(--layout-spacing-24);
        padding-top: var(--layout-spacing-16);
    }

    .featured-article-card__title {
        margin: 0;
        font-size: var(--typography-font-size-6xl);
        letter-spacing: var(--typography-letter-spacing-tight);
    }

    .featured-article-card__teaser {
        max-width: 50rem;
        margin: 0;
        ${theme.typography.body_large}
    }

    .featured-article-card__credits {
        display: flex;
        flex-direction: column;
        gap: var(--layout-spacing-8);

        &:empty {
            display: none;
        }
    }

    .featured-article-card__credits .author-credit__date {
        display: inline;
        margin-left: 0.4rem;
    }

    ${largeDesktop(css`
        margin-right: var(--layout-spacing-40);
    `)}

    ${largeTablet(css`
        flex-basis: 60rem;
        max-width: 60rem;

        .featured-article-card__image {
            border-radius: var(--effects-radius-base);
        }
    `)}

    ${smallTablet(css`
        flex-basis: 42rem;
        min-width: 28.8rem;
        max-width: 100%;
        margin-right: var(--layout-spacing-16);

        .featured-article-card__teaser {
            max-width: 48rem;
        }

        .featured-article-card__credits .author-credit__date {
            display: block;
            margin-left: 0;
        }
    `)}
`;
